import { createFileRoute } from '@tanstack/react-router';

import { Loading } from '@crossnokaye/ux-common';

import { AtlasLayout } from '@/components/layouts/atlas-layout';
import { AppConfigs } from '@/config';
import { useFeatureFlags } from '@/hooks/use-feature-flags';
import { useLaunchDarklyContext } from '@/hooks/use-launch-darkly-context';
import { AuthProvider } from '@/providers/auth/auth-provider';

const AuthedRouteComponent = () => {
  useLaunchDarklyContext();
  const { ldIsReady, canSeeRefreshTokens } = useFeatureFlags();

  if (!ldIsReady) {
    return <Loading />;
  }

  if (ldIsReady && !canSeeRefreshTokens) {
    window.location.href = AppConfigs.atlasEnvUrl.toString();
  }

  return <AtlasLayout />;
};

const RouteComponent = () => {
  return (
    <AuthProvider>
      <AuthedRouteComponent />
    </AuthProvider>
  );
};

export const Route = createFileRoute('/admin')({
  component: RouteComponent,
});
